/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';

import * as types from '../constants/ActionTypes';

const getInitialState = () => ({
  data: null,
  isLoading: false,
  error: null,
});

const initialState = getInitialState();

const DashboardData = (state = initialState, { type, error, data }) => {
  switch (type) {
    case types.LOAD_DASHBOARD_DATA_FAILURE:
      return { ...state, error, isLoading: false };
    case types.LOAD_DASHBOARD_DATA_SUCCESS:
      return { ...state, data, isLoading: false };
    case types.LOAD_DASHBOARD_DATA_REQUEST:
      return { ...state, isLoading: true };
    case types.CLEAR_DASHBOARD_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export const getServiceDetails = (state, service) => {
  const services = get(state, 'ServicesPage.Dashboard.data.tenant.services');
  if (!services) {
    return {};
  }
  // Sometimes the nested prop name is test, sometimes it's prod, we just want the first child
  const serviceData = services[Object.getOwnPropertyNames(services)[0]];
  return get(serviceData, `${service}[0].entity`) || {};
};

export const getServiceCredentials = (state, service) => {
  const { credentials } = getServiceDetails(state, service);

  if (service === 'bos') {
    return credentials && credentials.credentials && credentials.credentials.cos_hmac_keys
      ? {
          id: credentials.credentials.cos_hmac_keys.access_key_id,
          password: credentials.credentials.cos_hmac_keys.secret_access_key,
        }
      : {};
  }
  return {};
};

export const getPlatformMessagingCredentials = state => {
  const platformService = getServiceDetails(state, 'iotp');
  const org = get(platformService, 'credentials.entity.credentials.org');
  const apiKey = get(platformService, 'credentials.entity.credentials.apiKey');
  const apiToken = get(platformService, 'credentials.entity.credentials.apiToken');

  const masCredentials = get(state, 'currentUser.userData.iotpCredentials');

  return org
    ? { org, apiKey, apiToken }
    : {
        org: masCredentials && masCredentials.orgId,
        apiKey: masCredentials && masCredentials.apiKey,
        apiToken: masCredentials && masCredentials.apiToken,
      };
};

export const getPlatformUrl = state => {
  const platformService = getServiceDetails(state, 'iotp');
  return get(platformService, 'credentials.entity.credentials.http_host');
};

export const getAnalyticServicePipelineLogLocation = state => {
  const bosDetails = getServiceDetails(state, 'bos');
  return get(bosDetails, 'buckets.bos_logs_bucket') || null;
};

export default DashboardData;
